import { DatePicker as ArkUiDatePicker } from "@ark-ui/react";

export default function isDefaultDate(
  date: ArkUiDatePicker.DateValue,
  datePartsList: ArkUiDatePicker.DateValue[],
): boolean {
  return datePartsList.some(
    (dateParts) =>
      dateParts.year === date.year &&
      dateParts.month === date.month &&
      dateParts.day === date.day,
  );
}
